import React from "react";
// Assuming you have an icon component or similar
// import { Icon } from "@iconify/react";

export const MobileMenuToggleButton = ({ icon, handleClick }) => {
  // Determine which icon to display based on the 'icon' prop ('menu' or 'close')
  // Replace 'menu' and 'close' with your actual icon elements/components
  const iconToDisplay = icon === 'menu' ? '☰' : '✕'; // Example using text symbols

  return (
    <button
      className="nav-bar__toggle" // Use the class from nav-bar.css
      aria-label="Menu"
      onClick={handleClick}
    >
      {/* Render your actual icon component here */}
      {/* <Icon icon={icon === "menu" ? "mdi:menu" : "mdi:close"} /> */}
      {iconToDisplay}
    </button>
  );
};
